import React, {Component} from 'react';
import {Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Colxx} from '../components/common/CustomBootstrap';
import {withTranslation} from 'react-i18next';
import AlertsList from "./AlertsList";

class UserAlerts extends Component {
  render() {
    const {t, userId, history} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                {t('Alerts')}
              </CardTitle>
              <AlertsList userId={userId} history={history}/>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(UserAlerts);
